export type MemberSection =
  | 'landing'
  | 'onboarding-snapshot'
  | 'journey-report'
  | 'regenerative-medicine-ops'
  | 'annual-report'
  | 'composite-report'
  | 'action-plan'
  | 'ai-tools'
  | 'rule-action-audit'
  | 'labs'
  | 'documents'
  | 'extractions'
  | 'surveys'
  | 'omics-explorer'
  | 'member-app'
  | 'pulse';

export const MEMBER_SECTION_STORAGE_KEY = 'memberDetail.lastSection';
